import React from 'react';

import Event from './event';

class Events extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.appStateHash !== this.props.appStateHash ||
			nextProps.featureId !== this.props.featureId
		);
	}

	render() {
		const {isExpanded, events, eventPredicates, tags} = this.props;
		const containerClassName = isExpanded
			? 'bsknacht17-event-grid'
			: 'bsknacht17-event-list';
		const itemClassName = containerClassName + '__item';
		const prefixClassName = (element) => itemClassName + '__' + element;

		return (
			<ul className={containerClassName}>
				{events.map((event) => (
					<Event
						key={event.hash}
						tags={tags}
						isExpanded={isExpanded}
						eventPredicates={eventPredicates}
						event={event}
						itemClassName={itemClassName}
						prefixClassName={prefixClassName}
					/>
				))}
			</ul>
		);
	}
}

export default Events;
